<div class="confirmation-container">
  <div class="confirmation-message">You want to DELETE this product ?</div>
  <div class="confirmation-buttons">
    <button class="confirm-button" (click)="confirmDelete(true)">Yes</button>
    <button class="cancel-button" (click)="confirmDelete(false)">No</button>
  </div>
</div>
